var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"family-sharing"},[_c('div',{class:{ loading: !_vm.loaded }},[(!_vm.sharingIdCorrect)?_c('InvalidShareId'):(_vm.incorrectUser)?_c('IncorrectUser'):(_vm.loggedIn)?_c('LoggedInUser'):_c('AnonUser')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }